export default "<span class=\"title\"\r\n  >{{ titlePrefix | translate\r\n  }}<span class=\"title-id\">{{ titleText | async }}</span></span\r\n>\r\n";